export class LoggedUser {
  Id!: number;
  Name?: string;
  Email!: string;
  Mobile!: string;
  RoleName!: string;
  RoleId!: number;
  UserUniqueId!: string;
  IsAdmin: boolean = false;
  IsSuperAdmin: boolean = false;
  IsUser: boolean = false;
  IsActive: boolean = false;
}
